import { Col, DatePicker, Empty, Form, Input, Row, Select, Spin } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const CompanySelectField = ({ name, label, required, list, loading, onSearch, onChange, placeholder, disabled }) => (
  <Spin className="cmt-spin" spinning={!!loading}>
    <Form.Item
      name={name}
      label={label}
      rules={required ? [{ required: true, message: `${label} es requerido` }] : []}
    >
      <Select
        className="cmt-select"
        placeholder={placeholder}
        showSearch={!disabled}
        showArrow={false}
        filterOption={false}
        allowClear={!disabled}
        onSearch={onSearch}
        onChange={onChange}
        onClear={onChange ? () => onChange(null, null) : undefined}
        disabled={disabled}
        notFoundContent={
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<div className="empty-search">No hay coincidencias</div>}
          />
        }
      >
        {list?.map(option => (
          <Option key={option.id} value={option.id} company={option}>
            {option.business_name || option.name || option.fullname}
          </Option>
        ))}
      </Select>
    </Form.Item>
  </Spin>
);

const CompanyDataBlock = ({ companyData }) => {
  const { t } = useTranslation();
  const {
    loading,
    applicantLoading,
    applicantList,
    companies,
    childCompanies,
    costsCenters,
    branchOffices,
    showChildCompanies,
    fetchBranchOffices,
  } = companyData;

  useEffect(() => {
    fetchBranchOffices();
  }, [fetchBranchOffices]);

  return (
    <Row gutter={15}>
      <Col lg={8} xs={24}>
        <CompanySelectField
          name="user_id"
          label={t('reservations.generalDataForm.applicantLabel')}
          list={applicantList}
          loading={applicantLoading}
          placeholder={t('reservations.generalDataForm.applicantPlaceholder')}
          required={true}
          disabled
        />
      </Col>
      <Col lg={8} xs={24}>
        <CompanySelectField
          name="company_id"
          label={t('reservations.generalDataForm.companyLabel')}
          list={companies}
          loading={loading}
          placeholder={t('reservations.generalDataForm.companyPlaceholder')}
          required={true}
          disabled
        />
      </Col>
      <Col lg={8} xs={24}>
        <CompanySelectField
          name="outsourcing_id"
          label={t('reservations.generalDataForm.outsourcingLabel')}
          list={companies}
          placeholder={t('reservations.generalDataForm.outsourcingPlaceholder')}
          disabled
        />
      </Col>

      <Col lg={8} xs={24}>
        <CompanySelectField
          name="third_company_id"
          label={t('reservations.generalDataForm.thirdCompanyLabel')}
          list={companies}
          placeholder={t('reservations.generalDataForm.thirdCompanyPlaceholder')}
          disabled
        />
      </Col>
      <Col lg={8} xs={24}>
        <CompanySelectField
          name="invoice_company_id"
          label={t('reservations.generalDataForm.invoiceCompanyLabel')}
          list={companies}
          loading={loading}
          placeholder={t('reservations.generalDataForm.invoiceCompanyPlaceholder')}
          required={true}
        />
      </Col>
      {costsCenters?.length > 0 && (
        <Col lg={8} xs={24}>
          <Form.Item name="cost_center_id" label="Centro de costo">
            <Select
              className="cmt-select"
              placeholder="Ingrese el centro de costo"
              disabled
            >
              {costsCenters.map(option => (
                <Option key={option.id} value={option.id}>{option.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      )}

      {showChildCompanies && (
        <Col lg={8} xs={24}>
          <Form.Item name="child_company_id" label={t('reservations.generalDataForm.subCompanyLabel')}>
            <Select
              className="cmt-select"
              placeholder={t('reservations.generalDataForm.subCompanyPlaceholder')}
              disabled
            >
              {childCompanies?.map(option => (
                <Option key={option.id} value={option.id}>{option.business_name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      )}

      <Col lg={8} xs={24}>
        <Form.Item
          name="branch_office_id"
          label={t('reservations.generalDataForm.branchOfficeLabel')}
          rules={[{ required: true, message: 'Sede es requerida' }]}
        >
          <Select
            className="cmt-select"
            placeholder={t('reservations.generalDataForm.branchOfficePlaceholder')}
            disabled
          >
            {branchOffices?.map(office => (
              <Option key={office.id} value={office.id}>{office.name}</Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={8} xs={24}>
        <Form.Item
          name="reservation_date"
          label="Fecha de reserva (dd-mm-aaaa)"
          rules={[{ required: true, message: 'Fecha de reserva es requerida' }]}
        >
          <DatePicker
            disabled
            locale={locale}
            format="DD-MM-YYYY"
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>

      <Col lg={24} xs={24}>
        <Form.Item name="observations" label="Observaciones">
          <Input.TextArea
            className="cmt-input"
            autoSize={{ minRows: 2, maxRows: 6 }}
            placeholder="Escriba observaciones"
            disabled
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default CompanyDataBlock;
